import { forwardRef } from "react";
import cn from "mcn";

export const LiveChartsAlertIcon = forwardRef<
  SVGSVGElement,
  React.HTMLAttributes<SVGSVGElement> & {
    selected?: boolean;
    disableHover?: boolean;
    size?: string;
    disabled?: boolean;
  }
>(({ selected, disableHover, size, disabled, ...props }, ref) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: We have a custom tooltip
    <svg
      width={size ?? "30"}
      height={size ?? "30"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn(
        selected ? "nav-icon selected group" : "nav-icon group",
        props.className,
        disabled ? "bg-[var(--new-neutral-t50)] rounded-[var(--border-radius-rounded-lg,6px)]" : "",
        "hover:bg-[var(--neutral-tonal)] hover:rounded-[var(--border-radius-rounded-lg,6px)] focus:bg-[var(--neutral-tonal)] focus:rounded-[var(--border-radius-rounded-lg,6px)] focus:border focus:border-[var(--neutral-default,#5E5E5E)]",
      )}
      ref={ref}
    >
      <path
        d="M14 7.5C13.5506 7.5 13.1875 7.86309 13.1875 8.3125V8.8C11.334 9.17578 9.9375 10.816 9.9375 12.7812V13.2586C9.9375 14.452 9.49824 15.6047 8.70605 16.4984L8.51816 16.7092C8.30488 16.9479 8.2541 17.2906 8.38359 17.5826C8.51309 17.8746 8.80508 18.0625 9.125 18.0625H18.875C19.1949 18.0625 19.4844 17.8746 19.6164 17.5826C19.7484 17.2906 19.6951 16.9479 19.4818 16.7092L19.2939 16.4984C18.5018 15.6047 18.0625 14.4545 18.0625 13.2586V12.7812C18.0625 10.816 16.666 9.17578 14.8125 8.8V8.3125C14.8125 7.86309 14.4494 7.5 14 7.5ZM15.1502 20.0252C15.4549 19.7205 15.625 19.3066 15.625 18.875H14H12.375C12.375 19.3066 12.5451 19.7205 12.8498 20.0252C13.1545 20.3299 13.5684 20.5 14 20.5C14.4316 20.5 14.8455 20.3299 15.1502 20.0252ZM10.3793 7.89102C10.1482 7.64727 9.7623 7.63711 9.51855 7.8707C8.27441 9.05391 7.5 10.7271 7.5 12.5781C7.5 12.9158 7.77168 13.1875 8.10938 13.1875C8.44707 13.1875 8.71875 12.9158 8.71875 12.5781C8.71875 11.0725 9.34844 9.7166 10.359 8.7543C10.6027 8.52324 10.6129 8.1373 10.3793 7.89355V7.89102ZM17.641 8.7543C18.6516 9.7166 19.2812 11.0725 19.2812 12.5781C19.2812 12.9158 19.5529 13.1875 19.8906 13.1875C20.2283 13.1875 20.5 12.9158 20.5 12.5781C20.5 10.7271 19.7256 9.05391 18.484 7.8707C18.2402 7.63965 17.8543 7.64727 17.6232 7.89102C17.3922 8.13477 17.3998 8.5207 17.6436 8.75176L17.641 8.7543Z"
        style={disableHover ? { fill: "var(--neutral-default)" } : undefined}
        className={`${disableHover ? "" : "fill-[var(--neutral-default)] group-hover:fill-[var(--neutral-on-tonal)]"}`}
      />
    </svg>
  );
});
